import _typeof from "@babel/runtime/helpers/typeof";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Typed error taxonomy for everything between "a URL/File" and "rendered
 * rows". The UI maps `code` to a remediation message in one exhaustive
 * switch — no message sniffing anywhere.
 */

export var PackError = /*#__PURE__*/function (_Error) {
  function PackError(code, message, detail) {
    var _this;
    _classCallCheck(this, PackError);
    _this = _callSuper(this, PackError, [message]);
    _this.name = 'PackError';
    _this.code = code;
    _this.detail = detail;
    return _this;
  }
  _inherits(PackError, _Error);
  return _createClass(PackError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var isPackError = function isPackError(e) {
  return e instanceof PackError;
};

/** fetch aborts throw DOMException('AbortError') — duck-typed because some
 * test environments (Jest 27 node) have no DOMException global. */
var isAbortException = function isAbortException(e) {
  return _typeof(e) === 'object' && e !== null && e.name === 'AbortError';
};
export var isAbort = function isAbort(e) {
  return isPackError(e) && e.code === 'aborted' || isAbortException(e);
};

/** Wrap an unknown thrown value, preserving PackErrors and abort semantics. */
export function toPackError(e, fallback) {
  if (isPackError(e)) return e;
  if (isAbortException(e)) {
    return new PackError('aborted', 'operation aborted');
  }
  var message = e instanceof Error ? e.message : String(e);
  return new PackError(fallback, message);
}